export default __webpack_public_path__ + "static/media/lock_image_open.fc7966a0.png";